<template>
  <div id="app">
    <Navbar/>
    <router-view/>
    <Login />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Login from './components/Login.vue'

export default {
  components: {
    Navbar,
    Login
  },
  created() {
    this.$store.dispatch('checkLogin')
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
